import { useState, useEffect } from 'react';

// Diverse messages for the sign-up form
const formMessages = [
  "Pro tip: Use a strong password with numbers, letters, and symbols to keep your account secure!",
  "Excited to have you here! Make sure your password is something memorable but hard to guess.",
  "Once you're in, you'll have access to amazing learning resources. Let's start with a solid password!",
  "Your learning journey is about to begin! Choose a password that's at least 8 characters long.",
  "Security first! Mix uppercase, lowercase, numbers, and special characters for the best protection.",
  "Can't wait to show you what we have! After signing up, I recommend starting with our beginner courses.",
  "New here? No worries! Once you're in, check out our Python fundamentals—it's a great starting point.",
  "Ready to learn? After you sign up, explore our JavaScript courses to build interactive web apps!",
  "First time coding? Try our HTML & CSS basics after signing up—you'll be building websites in no time!",
  "Looking to level up? An advanced algorithms course is perfect once you've mastered the basics."
];

export const getRandomFormMessage = () => {
  const randomIndex = Math.floor(Math.random() * formMessages.length);
  return formMessages[randomIndex];
};

export function useSignUpFormChat({
  onStreamComplete,
  onStreamStart,
  isStreaming = true,
  onCharacterTyped
}: {
  onStreamComplete?: () => void;
  onStreamStart?: () => void;
  isStreaming?: boolean;
  onCharacterTyped?: () => void;
}) {
  const [displayedText, setDisplayedText] = useState('');
  const [isComplete, setIsComplete] = useState(false);
  const [currentMessage, setCurrentMessage] = useState('');

  // Generate a random message on mount
  useEffect(() => {
    setCurrentMessage(getRandomFormMessage());
  }, []);

  // Handle streaming
  useEffect(() => {
    if (!currentMessage) {
      setDisplayedText('');
      setIsComplete(false);
      return;
    }

    if (!isStreaming) {
      setDisplayedText(currentMessage);
      setIsComplete(true);
      if (onStreamComplete) onStreamComplete();
      return;
    }

    // Notify that streaming is starting
    if (onStreamStart) onStreamStart();

    setDisplayedText('');
    setIsComplete(false);
    let currentIndex = 0;

    const intervalId = setInterval(() => {
      if (currentIndex < currentMessage.length) {
        setDisplayedText(currentMessage.slice(0, currentIndex + 1));
        currentIndex++;
        if (onCharacterTyped) onCharacterTyped();
      } else {
        clearInterval(intervalId);
        setIsComplete(true);
        if (onStreamComplete) onStreamComplete();
      }
    }, 30);

    return () => clearInterval(intervalId);
  }, [currentMessage, isStreaming]);

  return {
    displayedText,
    isComplete,
    message: currentMessage
  };
}

